import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgGillyHicksStacked = function SvgGillyHicksStacked(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 108",
    fill: fill,
    width: width,
    height: height,
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "gilly hicks"), /*#__PURE__*/React.createElement("path", {
    d: "M91.2 60.6c7.4 0 13 2.7 16.9 7.4l-4.7 4.7c-2.9-3.6-7-5.5-12-5.5-9 0-15.7 6.5-15.7 16.8 0 10 6.5 16.8 15.3 16.8 5.3 0 9.4-2.3 12.6-6.4l4.8 4.3c-4 5.7-10.5 8.7-17.7 8.7-12.3 0-22-9.6-22-23.4 0-14.1 9.9-23.4 22.5-23.4Zm85.3.3c6.4 0 11.2 2.4 14.4 5.6l-4.5 4.5c-2.6-2.4-5.8-3.8-10-3.8-5.7 0-9.1 2.7-9.1 6.7 0 10 24.1 3.2 24.1 19.6 0 8.4-6.4 13.7-16 13.7-7.7 0-12.9-3.2-16.5-6.7l4.9-4.4c3.6 3.2 7.5 4.8 11.8 4.8 5.6 0 8.9-2.7 8.9-6.8 0-10.4-24-3.1-24-20 0-7.7 6.4-13.2 16-13.2Zm-118.7.5v45.3h-7.3V61.4h7.3Zm67.6 0V81h.2l18.9-19.6h9.1l-21.1 20.9 22.5 24.4h-9.6L125.5 84h-.2v22.7H118V61.4h7.4Zm-117.8 0v18.7h21.1V61.4h7.4v45.2h-7.4V86.9H7.6v19.7H.3V61.4h7.3ZM31.7.5c7.5 0 13.2 2.7 17.2 7.6l-4.7 4.6C41.4 9.1 37.1 7 31.9 7c-8.5 0-15.6 6.3-15.6 16.8 0 10.4 6.9 16.7 15.3 16.7 7.9 0 12.6-4.6 13.4-12.3H30.6V22h21.6c.1 1 .2 1.9.2 2.6 0 13.7-8.2 22.6-20.7 22.6-11.6 0-22.4-8.7-22.4-23.3C9.3 9.3 19.7.5 31.7.5Zm38.3.7v45.3h-7.3V1.2H70Zm54.9 0v38.5h18.7v6.8h-26V1.2h7.3Zm-33.3 0v38.5h18.7v6.8h-26V1.2h7.3Zm58.8.4 11.7 18.7 11.8-18.7h8.5l-16.7 25.2v19.3h-7.4V26.8h-.1l-17-25.2h9.2Z"
  }));
};
SvgGillyHicksStacked.propTypes = propTypes;

export { SvgGillyHicksStacked as default };
//# sourceMappingURL=GillyHicksStacked.js.map
